// extracted by mini-css-extract-plugin
export default {"actions":"actions_OkCancel-module_1DiNe"};